<template>
  <div class="mb20" v-loading="loading">
    <jd-title label="数据概况" style="margin-top: 30px"></jd-title>
    <div class="flexc-cen-x" v-for="(item, index) in commList" :key="index">
      <statisticsItem
        v-for="(chil, chilIndex) in item.children"
        :key="chilIndex"
        :data="dataOverview"
        :item="chil"
      ></statisticsItem>
    </div>
  </div>
</template>

<script>
import { orderDetailPageDataOverview,getTrialRebuyOrderDetailDataOverview , pointOrderDetailPageDataOverview} from "@/api/jhk/paradiseAndTaskCommonController.js";
import statisticsItem from "@/views/interactiveMarketing/activity/statisticsYunqi/statisticsItem.vue";
export default {
  props: {
    rowData: {
      // 活动数据
      type: Object,
      default: () => {},
    },
  },
  created() {},
  components: {
    statisticsItem,
  },
  computed: {
    dataList() {
      return [
        {
          children: [
            {
              label: "付款人数",
              prop: "payerCount",
              tips: "列表数据条数通过用户PIN排重",
            },
            {
              label: "付款订单",
              prop: "payOrderCount",
              tips: "订单列表条数",
            },
            {
              label: "付款金额",
              prop: "payAmount",
              tips: "订单列表订单金额总合",
            },
            {
              label: "付款件数",
              prop: "payQuantity",
              tips: "订单列表中的商品件数相加总合",
            },
            {
              label: "客单价（付款）",
              prop: "payCustomerUnitPrice",
              tips: "付款金额除以付款人数=客单价",
            },
            {
              label: "件单价（付款）",
              prop: "payItemUnitPrice",
              tips: "付款金额除以付款件数",
            },
          ],
        },
        {
          children: [
            {
              label: "完成人数",
              prop: "completedUserCount",
              tips: "列表数据中订单状态为完成的数据通过通过用户PIN排重",
            },
            {
              label: "完成订单数",
              prop: "completedOrderCount",
              tips: "列表数据中订单状态为完成的数据",
            },
            {
              label: "完成金额",
              prop: "completedAmount",
              tips: "列表数据中订单状态为完成的订单金额总合",
            },
            {
              label: "完成件数",
              prop: "completedQuantity",
              tips: "列表数据中订单状态为完成的商品件数相加总合",
            },
            {
              label: "客单价（完成）",
              prop: "completedCustomerUnitPrice",
              tips: "完成金额除以完成人数",
            },
            {
              label: "件单价（完成）",
              prop: "completedItemUnitPrice",
              tips: "完成金额除以完成件数",
            },
          ],
        },
        {
          children: [
            {
              label: "退款人数",
              prop: "refundUserCount",
              tips: "列表数据中订单状态为已取消的数据通过通过用户PIN排重",
            },
            {
              label: "退款订单数",
              prop: "refundOrderCount",
              tips: "列表数据中订单状态为取消的数据",
            },
            {
              label: "退款金额",
              prop: "refundAmount",
              tips: "列表数据中订单状态为取消的订单金额总合",
            },
            {
              label: "退款件数",
              prop: "refundQuantity",
              tips: "列表数据中订单状态为取消的商品件数相加总合",
            },
            {
              label: "退款率",
              prop: "refundRate",
              tips: "退款订单在列表数据中的占比",
            },
          ],
        },
      ];
    },
    newDataList() {
      return this.dataList.map(item => {
        item.children = item.children.filter(chil => chil.prop!='refundQuantity')
        return item
      })
    },
    commList() {
      return this.rowData.activityType == 52 ? this.newDataList : this.dataList
    }
  },
  data() {
    return {
      dataOverview: {},
      loading: false,
    };
  },
  methods: {
    getDataOverview(params = {}) {
      let data = {
        activityId: this.rowData.activityId,
      };
      data = { ...data, ...params };
      delete data.size;
      delete data.current;
      this.loading = true;
      let reqFn
      if(this.rowData.activityType == 52) {
        reqFn = getTrialRebuyOrderDetailDataOverview
      } else if(this.rowData.activityType == 9) {
        reqFn = pointOrderDetailPageDataOverview;
      } else {
        reqFn = orderDetailPageDataOverview
      }
      reqFn(data)
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.dataOverview = res.data || {};
          }
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
